import { DialogContextType } from '@/providers';
import { createContext } from 'react';

export const DialogContext = createContext<DialogContextType>({
  dialogState: [],
  isLoading: false,
  setIsLoading: () => {
    console.warn('Dialog ctx is not assigned');
  },
  openDialog: () => {
    console.warn('Dialog ctx is not assigned');
  },
  closeDialog: () => {
    console.warn('Dialog ctx is not assigned');
  },
});
